/** @file Frame ruler label step: the smallest 1-2-5 step whose labels stay at least minPx apart. */

const STEPS = [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000];

/** Frames between ruler labels at `pxPerFrame`; the largest step when even that is too dense. */
export function rulerStep(pxPerFrame: number, minPx: number): number {
  return STEPS.find((s) => s * pxPerFrame >= minPx) ?? STEPS[STEPS.length - 1] ?? 1;
}
